/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-07 16:47:37
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-08-14 14:47:07
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/index.js
 * @Description: p1
 */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import PropTypes from 'prop-types'
import s from '../form.css';
import { parseArrayToTable, parseStringToArray } from '../utils';
import classnames from 'classnames';
import { getVisual } from '../../../controller';

const defaultColorValue = '表头背景\t #1f4d78\n表头文本\t #fff\n边框\t #7f7f7f\n'

class Form extends React.Component {
  static propTypes = {
    onChange: PropTypes.func,
    children: PropTypes.node,
  }
  constructor(props) {
    super(props);

    this.state = {
      value: '',
      colorValue: defaultColorValue,
      dataset: [],
      tableColumns: [],
      tableList: [],
      tableColorList: [],
    }
  }

  componentDidMount () {
    this.loadData();
  }

  loadData = () => {
    const { onChange } = this.props;

    getVisual('9_table').then(value => {
      const _table = Form.parse(value);
      const _tempColor = Form.parseColor(defaultColorValue);

      this.setState({
        value: value,
        ..._table,
        ..._tempColor
      })
  
      typeof onChange === 'function' && onChange({
        ..._table,
        ..._tempColor
      });
    });
  }

  static parse = (str) => {
    const dataset = parseStringToArray(str);
    if (!dataset) return null;
    // 解析table
    const { columns: tableColumns, list: tableList} = parseArrayToTable(dataset, {
      handleColumn: (name, index) => ({
        title: name,
        style: {
          width: index === 0 ? 140 : 'auto',
          height: 32,
          fontSize: 16,
          textAlign: 'center',
        },
        colStyle: {
          textAlign: 'center',
          fontSize: 16,
          fontWeight: 500,
          height: 32,
          background: '#fff',
        }
      })
    })

    return {
      dataset,
      tableColumns,
      tableList,
    }
  }

  static parseColor = (str) => {
    const dataset = parseStringToArray(str);
    return {
      tableColorList: dataset.map(item => item[1]),
    }
  }

  onChange = (e) => {
    const { onChange } = this.props;
    const value = e.target.value;
    const tableData = Form.parse(value);
    this.setState({ value, ...tableData });

    typeof onChange === 'function' && onChange(tableData)
  }

  onChangeColor = (e) => {
    const { onChange } = this.props;
    const colorValue = e.target.value;
    const _color = Form.parseColor(colorValue);

    this.setState({
      colorValue,
      ..._color,
    })

    typeof onChange === 'function' && onChange(_color)
  }

  render() {
    return (
      <div className={s.root}>
        <div>数据设置</div>
        <textarea className={classnames(s.inputText)} value={this.state.value} onChange={this.onChange} />
        <div>颜色设置（颜色只和顺序有关）</div>
        <textarea className={classnames(s.inputText)} value={this.state.colorValue} onChange={this.onChangeColor} />
      </div>
    );
  }
}

export default withStyles(s)(Form);



// WEBPACK FOOTER //
// src/routes/visualChart/P9/FormTable.js